import { Button, Center, Flex, Icon, Text } from "@chakra-ui/react";
import { TbWallet } from "react-icons/tb";
import { useCallback, useEffect, useState } from "react";
import {
  CarteiraEndpoints,
  getWalletBalanceFormatted
} from "components/carteira-components/utils";
import { useApplicationContext } from "contexts/ApplicationContext";
import {
  ModalAdicionarSaldoStorm,
  openModalAdicionarSaldoStorm
} from "components/carteira-components/modal-adicionar-saldo-storm";
import {
  ModalAdicionarSaldoPIX,
  openModalAdicionarSaldoPIX
} from "components/carteira-components/modal-adicionar-saldo-pix";
import { PIXIcon } from "components/vectors/pix-icon";
import { CashIcon } from "components/vectors/cash-icon";

export function WalletBalanceCard() {
  const [carteiraBalance, setCarteiraBalance] = useState(0);
  const { user } = useApplicationContext();

  const getCarteiraBalance = useCallback(async () => {
    try {
      const data = await CarteiraEndpoints.getSaldoCarteira(
        user.userData.customerId!
      );
      setCarteiraBalance(getWalletBalanceFormatted(data.saldos));
    } catch (error) {
      console.error("Erro ao obter saldo da carteira:", error);
    }
  }, [user.userData.customerId]);

  useEffect(() => {
    getCarteiraBalance();
    const intervalId = setInterval(() => {
      getCarteiraBalance();
    }, 3000);
    return () => clearInterval(intervalId);
  }, [getCarteiraBalance]);

  return (
    <Flex
      bg="blue.50"
      border="1px"
      borderColor="blue.100"
      borderRadius="lg"
      px="24px"
      py="8px"
      mb={4}
      direction={{ base: "column", sm: "row" }}
      align="center"
      justify="space-between"
      gap={4}
    >
      <Flex align="center" gap={3}>
        <Center
          p={2}
          bg="white"
          borderRadius="full"
          boxShadow="sm"
          w="40px"
          minW="40px"
          h="40px"
        >
          <Icon as={TbWallet} w={5} h={5} color="blue.600" />
        </Center>
        <Flex flexDir="column" fontSize="12px" color="blue.700">
          <Text fontWeight="semibold" fontSize="12px">
            Saldo da carteira
          </Text>
          <Text>
            Saldo disponível:{" "}
            <Text as="strong">
              R$ {carteiraBalance.toFixed(2).replace(".", ",")}
            </Text>
          </Text>
        </Flex>
      </Flex>

      <Flex align="center" gap="6px" w={{ base: "full", sm: "auto" }}>
        <ModalAdicionarSaldoStorm saldoAtual={carteiraBalance} />
        <ModalAdicionarSaldoPIX />
        <Flex direction="column" gap="4px">
          <Button
            variant="secondary"
            w="100%"
            fontSize="12px"
            bg="white"
            border="1px"
            borderColor="blue.200"
            color="blue.700"
            _hover={{ bg: "blue.50", borderColor: "blue.300" }}
            leftIcon={<PIXIcon width="12px" height="12px" />}
            size="xs"
            h="20px"
            onClick={() => openModalAdicionarSaldoPIX()}
          >
            Adicionar saldo via PIX
          </Button>
          {user.userData.type !== "PARCEIRO_GERENTE_VAREJO" &&
            user.userData.parentCustomerUserType !==
              "PARCEIRO_GERENTE_VAREJO" && (
              <Button
                variant="secondary"
                w="100%"
                fontSize="12px"
                bg="white"
                border="1px"
                borderColor="blue.200"
                color="blue.700"
                _hover={{ bg: "blue.50", borderColor: "blue.300" }}
                leftIcon={<CashIcon width="12px" height="12px" />}
                size="xs"
                h="20px"
                onClick={() => openModalAdicionarSaldoStorm()}
              >
                Adicionar saldo C/C Grupo Nova
              </Button>
            )}
        </Flex>
      </Flex>
    </Flex>
  );
}
